export default "__VITE_ASSET__DVxkNJcI__";